module.exports = __webpack_public_path__ + "static/img/image@2x (8).fea92a8c.png";